import React from "react";

const Modal = ({
  isOpen,
  onClose,
  children,
  overlayClassName = "",
  panelClassName = "",
  contentClassName = ""
}) => {
  if (!isOpen) return null;

  const handleModalClick = (e) => {
    // Prevent closing when clicking inside the modal content
    e.stopPropagation();
  };

  const handleOverlayClick = () => {
    // Close modal when clicking on overlay (background)
    onClose();
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${overlayClassName}`.trim()}
      onClick={handleOverlayClick} // Close modal when clicking outside
    >
      <div
        className={`relative bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto modal-scrollbar m-4 ${panelClassName}`.trim()}
        onClick={handleModalClick} // Prevent close when clicking inside modal content
      >
        {/* Close Button */}
        <button
          onClick={(e) => {
            e.stopPropagation(); // Prevent bubbling
            onClose(); // Close modal
          }}
          className="absolute top-4 right-4 z-10 text-gray-500 hover:text-black text-2xl bg-white rounded-full w-8 h-8 flex items-center justify-center shadow-md"
          aria-label="Close modal"
        >
          &times;
        </button>

        {/* Modal Content - Scrollable */}
        <div className={`p-6 pt-12 ${contentClassName}`.trim()}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
